import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-description-tax',
	templateUrl: './description-tax.component.html',
	styleUrls: ['./description-tax.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DescriptionTaxComponent implements OnInit {

	@Input() images: Array<string>;
	@Input() description: string;

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/description-tax/description-tax.component.ts